/**
 * Transforma um número para o formato localizado com '.' como separador.
 *
 * @param value Número como `number`
 * @returns Número com pontos separadores a cada três casas decimais
 * e uma vírgula separando as casas decimais até três no máximo, se houver
 */

export const formatNumber = (value: number | undefined) => {
  if (value === undefined || isNaN(value)) {
    return '';
  }
  return value.toLocaleString('pt-BR');
};

/** Transforma uma string numérica para a localização brasileira.
 *
 * @param value String não formatada como pt-BR
 * @returns Número com pontos separadores a cada três casas decimais
 * e uma vírgula separando as casas decimais até três no máximo, se houver
 */

export const formatStringToBR = (value: string | undefined) => {
  if (value === undefined || value === '') {
    return '';
  }
  let valueNumber = parseFloat(value.replaceAll(',', ''));
  return formatNumber(valueNumber);
};

/** Transforma uma string formatada como "ptBR" em seu valor numérico
 *
 * @param value String numérica formatada
 * @returns Valor numérico da string como number
 */

export const removeNumberFormat = (format: string | undefined) => {
  if (format === undefined || format === '') {
    return undefined;
  }
  return parseFloat(format.replaceAll('.', '').replaceAll(',', '.'));
};
